import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './index.module.css';

const CTATiles = ({ content = {} }) => {
  const { ariaLabel = 'Key tasks', tiles = [] } = content;

  return (
    <nav aria-label={ariaLabel} className="cta-tiles">
      <ul className="cta-tiles__list">
            {tiles.map((tile) => (
              <li key={tile.href} className="cta-tiles__item">
                <Link title={tile.title} to={tile.href}>
                  <div className="cta-tiles__link">
                    <div className="field-title cta-tiles__title">
                      {tile.title}
                    </div>
                    {tile.description && (
                      <div className="field-summary field-subtitle cta-tiles__description">
                        {tile.description}
                      </div>
                    )}
                  </div>
                </Link>
              </li>
            ))}
      </ul>
    </nav>
  );
};

CTATiles.propTypes = {
  content: PropTypes.shape({
    ariaLabel: PropTypes.string,
    tiles: PropTypes.arrayOf(PropTypes.shape({
      title:       PropTypes.string.isRequired,
      href:        PropTypes.string.isRequired,
      description: PropTypes.string,
    })),
  }),
};

export default CTATiles;
